export const alarmSystem = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR ALARMANLAGEN-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const airConditioning = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR KLIMA-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const assembling = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR MONTAGE-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const architect = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR ARCHITEKT-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const awnings = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR SONNENSTOREN-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const balcony = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR BALKON-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const bath = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR BAD-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const broker = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR IMMOBILIEN-PROJEKT!',
  subTitle: 'Von geprüften Maklern aus Ihrer Region',
}

export const carpenter = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR SCHREINER-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const carport = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR CARPORT-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const chippie = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR ZIMMERMANN-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const electrician = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR ELEKTRIKER-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const facade = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR FASSADEN-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const fences = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR ZAUN-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const floorer = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR BODENLEGER-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const garage = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR GARAGEN-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const gardener = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR GÄRTNER-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const heating = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR HEIZUNG-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const kitchen = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR KÜCHEN-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const metalConstruction = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR METALLBAU-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const painter = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR MALER-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const paver = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR PLATTENLEGER-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const pergola = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR PERGOLA-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const railing = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR GELÄNDER-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const rollerBlinds = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR STOREN-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const roofer = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR DACHDECKER-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const solarPlants = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR SOLAR-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const stair = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR TREPPEN-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const waterConditioning = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR WASSER&shy;AUF&shy;BEREITUNGS-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const whirlpool = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR WHIRLPOOL-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const window = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR FENSTER-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const wintergarden = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR WINTERGARTEN-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}

export const chargingColumn = {
  title: 'ERHALTEN SIE BIS ZU DREI OFFERTEN<br /> FÜR IHR LADESTATIONEN-PROJEKT!',
  subTitle: 'Von geprüften Handwerksbetrieben aus Ihrer Region',
}
